// Core
import React from 'react';
import { Box, Flex, Grid, Text } from '@chakra-ui/react';

// Components
import Card from 'components/Card/Card';
import Phone from './components/Phone';
import Email from './components/Email';
import Password from './components/Password';
import Delete from './components/Delete';

const Security = (props) => { 
  const { userData } = props;

  return (
  	<>
  		{ userData && ( <Phone userData={userData} />) }
    	{ userData && ( <Email userData={userData} />) }
    	{ userData && ( <Password userData={userData} />) }
    	{ userData && ( <Delete userData={userData} />) }
    </>
  );
};

export default Security;
